<!--用户页 管理员数据表-->
<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="activityInfos"
            hide-default-footer
            class="elevation-1"
            disable-sort
            :dark="theme.tableDark"
            :loading="loading"
            loading-text="数据加载中..."
            no-data-text="未查询到数据"
        >
            <template v-slot:item.name="{ item }">
                <el-link
                    type="primary"
                    icon="el-icon-view el-icon--right"
                    class="ml-3"
                    @click="showDetails(item)"
                >
                    {{ item.name }}
                </el-link>
            </template>
            <template v-slot:item.end_time="{ item }">
                {{ timestampToTime(item.end_time) }}
            </template>
            <template v-slot:item.type="{ item }">
                {{ showTypeText(item.type) }}
            </template>
            <template v-slot:item.int_param2="{ item }">
                {{ showCouponText(item.int_param2) }}
            </template>
        </v-data-table>
    </div>
</template>

<script>
import util from "@/util";
import { mapState } from "vuex";
import store from "@/store";
export default {
    data() {
        return {
            headers: [
                { text: "名称", value: "name" },
                { text: "创建时间", value: "createtime" },
                { text: "结束时间", value: "end_time" },
                { text: "类型", value: "type" },
                { text: "优惠卷", value: "int_param2" },
                { text: "领取优惠卷张数", value: "int_param1" },
                { text: "", value: "editor" },
            ],
            typeText: [
                {
                    id: 0,
                    value: "优惠券",
                },
            ],
        };
    },
    mounted() {
        this.getcouponInfos();
    },
    props: {
        activityInfos: null,
        loading: Boolean,
    },
    watch: {
        loading: {
            handler(val) {
                // console.log(val);
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["theme", "couponInfos"]),
    },
    methods: {
        async getcouponInfos() {
            let params = {
                postData: {},
                callback: () => {
                    this.loading = false;
                },
            };
            await store.dispatch("getCoupon", params);
        },
        showDetails(data) {
            this.$emit("edit", data);
        },
        timestampToTime(timestamp) {
            var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + "-";
            var M =
                (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
                "-";
            var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
            var h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
            var m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
            var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            return Y + M + D + h + m + s;
        },
        showTypeText(type) {
            let text = "";
            for (let i = 0; i < this.typeText.length; i++) {
                if (type == this.typeText[i].id) {
                    text = this.typeText[i].value;
                }
            }
            return text;
        },
        showCouponText(id) {
            let text = "";
            if (this.couponInfos) {
                for (let i = 0; i < this.couponInfos.length; i++) {
                    if (id == this.couponInfos[i].id) {
                        text = this.couponInfos[i].name;
                    }
                }
            }
            return text;
        },
    },
};
</script>
